export function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}
export function isWithinRange(value, min, max) {
    return min <= value && value <= max;
}
